import { render, staticRenderFns } from "./TeamMemberDef.vue?vue&type=template&id=0c0f26b4&scoped=true&"
import script from "./TeamMemberDef.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDef.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDef.vue?vue&type=style&index=0&id=0c0f26b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f26b4",
  null
  
)

export default component.exports